import { AxiosInstance } from "axios";
import ApiClient from "./ApiClient";
import {
  ApplicationQuestionsRequest,
  ApplicationQuestion,
  SuggestionRequest,
  SuggestionResponse,
} from "../types/AI";
import { DateRequest, CampaignDates } from "../types/Campaign";

// Base URL for AI micro-service
const API_URL = process.env.REACT_APP_AI_API_URL ?? "";

class AIService {
  private apiClient: AxiosInstance;

  constructor() {
    this.apiClient = new ApiClient(API_URL).getClient();
  }

  /* -------------------------------------------------------------------------- */
  /*                                Health check                                */
  /* -------------------------------------------------------------------------- */

  public health = async (): Promise<{ status: string }> => {
    const res = await this.apiClient.get<{ status: string }>('/ai/health');
    return res.data;
  };

  /* -------------------------------------------------------------------------- */
  /*                     Application Questions – generation                     */
  /* -------------------------------------------------------------------------- */

  public generateApplicationQuestions = async (
    payload: ApplicationQuestionsRequest
  ): Promise<ApplicationQuestion[]> => {
    const res = await this.apiClient.post<ApplicationQuestion[]>(
      '/application/questions/generate',
      payload
    );
    return res.data;
  };

  /* -------------------------------------------------------------------------- */
  /*                           Field Suggestions (AI)                           */
  /* -------------------------------------------------------------------------- */

  public generateSuggestion = async (
    payload: SuggestionRequest
  ): Promise<SuggestionResponse> => {
    const res = await this.apiClient.post<SuggestionResponse>(
      '/suggestions/generate',
      payload
    );
    return res.data;
  };

  /* -------------------------------------------------------------------------- */
  /*                         Campaign Dates Generation                        */
  /* -------------------------------------------------------------------------- */

  public generateDates = async (
    payload: DateRequest
  ): Promise<CampaignDates> => {
    const res = await this.apiClient.post<CampaignDates>(
      '/dates/generate',
      payload
    );
    return res.data;
  };
}

export default AIService;
